<template>
  <b-card title="Add PCC">
    <b-form @submit.prevent="createPCC">
      <b-row>
        <b-col cols="12">
          <b-form-group label-for="title">
            <template slot="label">
              <span>Title <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="title" required v-model="form.title" />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-row>
            <template v-for="(speaker, i) in speakers">
              <b-col
                cols="12"
                sm="12"
                :lg="speakers.length > 1 ? (i != 0 ? 5 : 7) : 7"
                :key="`speaker-${speaker.key}`"
              >
                <b-form-group label-for="speaker">
                  <template slot="label">
                    <span>Speaker <strong class="text-danger">*</strong></span>
                  </template>
                  <b-form-input
                    id="speaker"
                    required
                    v-model="speaker.speaker"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="12" lg="5" :key="`position-${speaker.key}`">
                <b-form-group label-for="position">
                  <template slot="label">
                    <span>Position <strong class="text-danger">*</strong></span>
                  </template>
                  <b-form-input
                    id="position"
                    required
                    v-model="speaker.position"
                  />
                </b-form-group>
              </b-col>
              <b-col
                class="d-flex align-items-center mb-1 mb-lg-0"
                v-if="speakers.length > 1 && i > 0"
                cols="12"
                sm="12"
                lg="2"
                :key="`delete-${speaker.key}`"
              >
                <b-form-group class="mb-0 w-100">
                  <b-button
                    block
                    type="button"
                    variant="outline-secondary"
                    @click="removeSpeaker(speaker.key)"
                  >
                    Remove
                  </b-button>
                </b-form-group>
              </b-col>
            </template>
            <b-col cols="12" class="mb-1">
              <b-button
                @click="addSpeaker"
                variant="outline-primary"
                type="button"
              >
                Add Speaker
              </b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" sm="12" lg="6">
          <b-form-group label-for="category">
            <template slot="label">
              <span>Portfolio <strong class="text-danger">*</strong></span>
            </template>
            <v-select
              v-model="selectedCategories"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              multiple
              required
              label="name"
              :options="productCategories"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" sm="12" lg="6">
          <b-form-group label-for="product">
            <template slot="label">
              <span>Product <strong class="text-danger">*</strong></span>
            </template>
            <v-select
              v-model="selectedProducts"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              multiple
              required
              label="PRODUCT"
              :options="filteredProducts"
              :get-option-key="getProductOptionKey"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" lg="6">
          <b-form-group>
            <template slot="label">
              <span>Start Date <strong class="text-danger">*</strong></span>
            </template>
            <flat-pickr
              v-model="form.start_datetime"
              required
              class="form-control"
              :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" lg="6">
          <b-form-group>
            <template slot="label">
              <span>End Date <strong class="text-danger">*</strong></span>
            </template>
            <flat-pickr
              v-model="form.end_datetime"
              required
              class="form-control"
              :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label-for="address">
            <template slot="label">
              <span>Address <strong class="text-danger">*</strong></span>
            </template>
            <b-form-textarea
              rows="3"
              required
              id="address"
              v-model="form.address"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label-for="link">
            <template slot="label">
              <span>Link Conference</span>
            </template>
            <b-form-input
              id="link"
              v-model="form.link"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label-for="description">
            <template slot="label">
              <span>Description <strong class="text-danger">*</strong></span>
            </template>
            <snote v-model="form.description" ref="snote"/>
            <!-- <quill-editor
              v-model="form.description"
              id="description"
              :options="editorOption"
            /> -->
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="Banner" label-for="dropzone-banner-image">
          <span class="text-muted font-italic">(1920 pixels x 1080 pixels)</span>
            <div id="dropzone-banner-image" class="dropzone dropzone-area mb-3">
              <div class="dz-message">
                Drop files here or click button to upload. <br />(Max. size 10MB)
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label-for="dropzone-banner-home-image">
            <template slot="label">
              <span>Banner Home <strong class="text-danger">*</strong></span>
            </template>
            <span class="text-muted font-italic d-block mb-50">Same resolution as Banner Website: 1200px x 350px.</span>
            <div id="dropzone-banner-home-image" class="dropzone dropzone-area mb-3">
              <div class="dz-message">
                Drop files here or click button to upload. <br />(Max. size 2MB)
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label-for="dropzone-banner-history-image">
            <template slot="label">
              <span>Banner History <span class="text-muted">(Optional)</span></span>
            </template>
            <span class="text-muted font-italic d-block mb-50">Same resolution as Banner Website: 1200px x 350px.</span>
            <span class="text-muted font-italic d-block mb-50">Replaces the Banner Home in the Home slider once this PCC is no longer active or its date has passed (shown only when the "Publish History" toggle is enabled in the PCC List)</span>
            <div id="dropzone-banner-history-image" class="dropzone dropzone-area mb-3">
              <div class="dz-message">
                Drop files here or click button to upload. <br />(Max. size 2MB)
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="Attachments" label-for="dropzone-attachments">
            <div id="dropzone-attachments" class="dropzone dropzone-area mb-3">
              <div class="dz-message">
                Drop files here or click button to upload. <br />(Max. size 100MB)
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="Video" label-for="dropzone-video">
            <div id="dropzone-video" class="dropzone dropzone-area mb-3">
              <div class="dz-message">
                Drop files here or click button to upload.
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group class="d-flex justify-content-end">
            <b-button
              :to="{ name: 'admin-pcc-index' }"
              variant="light"
              class="mr-1"
            >
              Cancel
            </b-button>
            <b-button
              :disabled="isLoading"
              type="submit"
              variant="primary"
              class="mr-1"
            >
              Save
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BFormSelect,
  BFormSelectOption,
  BButton,
  BFormTextarea,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import snote from '../product/summernote.vue'

const PRODUCT_DROPDOWN_LIMIT = 100

export default {
  components: {
    BCard,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormSelect,
    BFormSelectOption,
    quillEditor,
    BButton,
    BFormTextarea,
    flatPickr,
    vSelect,
    'snote': snote
  },

  data() {
    return {
      isLoading: false,
      editorOption: {
        theme: 'snow',
      },
      form: {
        title: '',
        start_datetime: '',
        end_datetime: '',
        address: '',
        description: '',
        banner_image: '',
        banner_image_home: '',
        banner_image_history: '',
        pcc_video: [],
        link: '',
      },
      speakers: [{ key: Math.random(), speaker: '', position: '' }],
      selectedProducts: [],
      selectedCategories: [],
      attachments: [],
      productCategories: [],
      products: [],
      productRequestId: 0,
      dzBannerIns: null,
      dzBannerHomeIns: null,
      dzBannerHistoryIns: null,
      dzAttachmentsIns: null,
      dzVideo: null,
    }
  },

  computed: {
    filteredProducts() {
      if (!this.selectedCategories.length) {
        return this.products
      }
      const selectedIds = new Set()
      const selectedNames = new Set()

      const normalizeId = value => {
        if (value === null || value === undefined || value === '') return null
        const stringValue = String(value).trim()
        if (stringValue === '') return null
        if (!Number.isNaN(Number(stringValue))) return String(Number(stringValue))
        return null
      }
      const normalizeName = value => {
        if (value === null || value === undefined || value === '') return null
        return String(value).trim().toLowerCase()
      }

      this.selectedCategories.forEach(category => {
        if (!category) return
        const ids = [
          category.id,
          category.ID,
          category.category_id,
          category.product_category_id,
        ]
        ids.forEach(id => {
          const normalized = normalizeId(id)
          if (normalized) selectedIds.add(normalized)
        })
        const names = [category.name, category.NAME, category.category_name]
        names.forEach(name => {
          const normalized = normalizeName(name)
          if (normalized) selectedNames.add(normalized)
        })
      })

      if (!selectedIds.size && !selectedNames.size) {
        return this.products
      }

      const extractProductCategory = product => {
        const ids = []
        const names = []
        const pushId = value => {
          const normalized = normalizeId(value)
          if (normalized) ids.push(normalized)
        }
        const pushName = value => {
          const normalized = normalizeName(value)
          if (normalized) names.push(normalized)
        }
        const pushRef = ref => {
          if (!ref || typeof ref !== 'object') return
          pushId(ref.id)
          pushId(ref.ID)
          pushId(ref.category_id)
          pushId(ref.product_category_id)
          pushName(ref.name)
          pushName(ref.NAME)
          pushName(ref.category_name)
        }

        pushRef(product.category)
        pushRef(product.product_category_details)
        pushRef(product.product_category)
        pushRef(product.category_details)

        pushId(product.category_id)
        pushId(product.categoryId)
        pushId(product.product_category_id)
        pushId(product.PROD_CATEGORY_ID)
        if (product.PROD_CATEGORY) {
          const normalizedId = normalizeId(product.PROD_CATEGORY)
          if (normalizedId) {
            ids.push(normalizedId)
          } else {
            pushName(product.PROD_CATEGORY)
          }
        }
        pushName(product.PROD_CATEGORY_NAME)

        return { ids, names }
      }

      return this.products.filter(product => {
        const { ids, names } = extractProductCategory(product)
        const hasId = ids.some(id => selectedIds.has(id))
        const hasName = names.some(name => selectedNames.has(name))
        return hasId || hasName
      })
    },
  },

  watch: {
    selectedCategories: {
      handler() {
        if (!this.selectedCategories.length) {
          this.products = []
          this.selectedProducts = []
          return
        }
        this.fetchProductsByCategories()
      },
      deep: true,
    },
    products() {
      this.syncSelectedProductsWithCategories()
    },
  },

  mounted() {
    this.initDropzone()
    this.getProductCategory()
  },

  destroyed() {
    this.dzBannerIns.disable()
    this.dzBannerHomeIns.disable()
    this.dzBannerHistoryIns.disable()
    this.dzAttachmentsIns.disable()
  },

  methods: {
    getProductOptionKey(option) {
      return option?.KODE ?? option?.id ?? option?.PRODUCT
    },

    initDropzone() {
      const optionsImg = {
        maxFiles: 1,
        maxFilesize:10,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        acceptedFiles: 'image/jpeg,image/jpg',
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }

      const optionsVideo = {
        maxFiles: 2,
        timeout: 1800000,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        acceptedFiles: "video/*",
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }

      const options = {
        maxFiles: 1,
        maxFilesize:100,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }

      const { drawBannerImage, deleteTempFile } = this
      this.dzBannerIns = new window.Dropzone('#dropzone-banner-image', {
        url: `${process.env.VUE_APP_API_HOST}/api/pcc/banner/upload`,
        ...optionsImg,
        maxFilesize: 2,
        init() {
          this.on('success', (file, res) => drawBannerImage(res.data))
          this.on('removedfile', () => deleteTempFile())
          this.on('addedfile', (file) => {
            const img = new Image()
            img.onload = () => {
              if (img.width !== 1920 || img.height !== 1080) {
                this.removeFile(file)
                alert('Image must be 1920 x 1080 pixels.')
              }
            }
            img.src = URL.createObjectURL(file)
          })
        },
      })

      const { drawBannerImageHome, removeBannerImageHome } = this
      this.dzBannerHomeIns = new window.Dropzone('#dropzone-banner-home-image', {
        url: `${process.env.VUE_APP_API_HOST}/api/pcc/banner-home/upload`,
        ...optionsImg,
        maxFilesize: 2,
        init() {
          this.on('success', (file, res) => drawBannerImageHome(res.data))
          this.on('removedfile', () => removeBannerImageHome())
        },
      })

      const { drawBannerImageHistory, removeBannerImageHistory } = this
      this.dzBannerHistoryIns = new window.Dropzone('#dropzone-banner-history-image', {
        url: `${process.env.VUE_APP_API_HOST}/api/pcc/banner-history/upload`,
        ...optionsImg,
        maxFilesize: 2,
        init() {
          this.on('success', (file, res) => drawBannerImageHistory(res.data))
          this.on('removedfile', () => removeBannerImageHistory())
        },
      })

      const { drawAtachments, deleteTempAttachemts } = this
      this.dzAttachmentsIns = new window.Dropzone('#dropzone-attachments', {
        ...options,
        url: `${process.env.VUE_APP_API_HOST}/api/pcc/upload`,

        maxFiles: 5,
        maxFilesize: 50,
        init() {
          this.on('success', (file, res) => drawAtachments(file, res.data))
          this.on('removedfile', file => deleteTempAttachemts(file))
        },
      })

      const { drawVideo,deleteTempVideo } = this
      this.dzAttachmentsIns = new window.Dropzone('#dropzone-video', {
        ...optionsVideo,
        url: `${process.env.VUE_APP_API_HOST}/api/pcc/upload/video`,

        maxFilesize: 2000,
        init() {
          this.on('success', (file, res) => drawVideo(file, res.data))
          this.on('removedfile', file => deleteTempVideo(file))
        },
      })
    },

    drawBannerImage(imagePath) {
      this.form.banner_image = imagePath
    },

    drawBannerImageHome(imagePath) {
      this.form.banner_image_home = imagePath
    },

    drawBannerImageHistory(imagePath) {
      this.form.banner_image_history = imagePath
    },

    drawVideo(file, path) {
      this.form.pcc_video.push({ uuid: file.upload.uuid, path })
    },

    drawAtachments(file, path) {
      this.attachments.push({ uuid: file.upload.uuid, path })
    },

    deleteTempAttachemts(file) {
      const deleteFileTempUrl = '/pcc/destroy'
      const uuid = file.upload.uuid
      const [attachment] = this.attachments.filter(
        attachment => attachment.uuid == uuid
      )

      this.$http
        .post(deleteFileTempUrl, {
          file: attachment.path,
        })
        .then(() => {
          this.attachments = this.attachments.filter(
            attachment => attachment.uuid != uuid
          )
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
    },

    deleteTempVideo(file) {
      const deleteFileTempUrl = '/pcc/destroy'
      const uuid = file.upload.uuid
      const [attachment] = this.form.pcc_video.filter(
        attachment => attachment.uuid == uuid
      )

      this.$http
        .post(deleteFileTempUrl, {
          file: attachment.path,
        })
        .then(() => {
          this.form.pcc_video = this.form.pcc_video.filter(
            attachment => attachment.uuid != uuid
          )
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
    },

    deleteTempFile() {
      const deleteFileTempUrl = '/pcc/destroy'

      if (this.form.banner_image) {
        this.$http
          .post(deleteFileTempUrl, {
            file: this.form.banner_image,
          })
          .then(() => {
            this.form.banner_image = ''
          })
          .catch(({ data }) => {
            this.$notif('Error', `${data.message}`, 'error')
          })
      }
    },

    // Clear the form field synchronously so validation (`createPCC`) never sees a stale
    // path while the cleanup request for the uploaded temp file is still in flight —
    // that race previously let a removed banner slip through and get saved anyway.
    removeBannerImageHome() {
      const filePath = this.form.banner_image_home
      this.form.banner_image_home = ''
      if (filePath) {
        this.$http
          .post('/pcc/destroy', { file: filePath })
          .catch(({ data }) => {
            this.$notif('Error', `${data.message}`, 'error')
          })
      }
    },

    removeBannerImageHistory() {
      const filePath = this.form.banner_image_history
      this.form.banner_image_history = ''
      if (filePath) {
        this.$http
          .post('/pcc/destroy', { file: filePath })
          .catch(({ data }) => {
            this.$notif('Error', `${data.message}`, 'error')
          })
      }
    },

    async getProductCategory() {
      return await this.$http.get(`/product-category/take/all`).then(res => {
        this.productCategories = res.data.data.records
      })
    },

    async fetchProductsByCategories() {
      const categoryIds = this.selectedCategories
        .map(category =>
          category?.id ??
          category?.ID ??
          category?.category_id ??
          category?.product_category_id
        )
        .filter(id => id !== null && id !== undefined && id !== '')

      if (!categoryIds.length) {
        this.products = []
        this.selectedProducts = []
        return
      }

      const requestId = ++this.productRequestId
      this.products = []
      const mapRequest = {
        map: {
          KODE: 's',
          PRODUCT: 's',
          PROD_CATEGORY: 'd',
          product_category_details: 'd',
          category: 'd',
          category_id: 'd',
        },
      }

      try {
        const responses = await Promise.all(
          categoryIds.map(categoryId =>
            this.$http.post(
              `/product/browse/take/${PRODUCT_DROPDOWN_LIMIT}/skip/0/category/${categoryId}/orderBy.PRODUCT/asc/published/true`,
              mapRequest
            )
          )
        )
        if (requestId !== this.productRequestId) return
        const merged = []
        const seen = new Set()
        responses.forEach(({ data }) => {
          const records = data?.data?.records || []
          records.forEach(item => {
            const key = item?.KODE ?? item?.id ?? item?.PRODUCT
            if (!key || seen.has(key)) return
            seen.add(key)
            merged.push(item)
          })
        })
        this.products = merged
      } catch (error) {
        this.$notif('Error', `${error.message || error}`, 'error')
      }
    },

    syncSelectedProductsWithCategories() {
      if (!this.selectedCategories.length || !this.products.length) return
      const allowed = new Set(
        this.filteredProducts
          .map(product => product?.KODE)
          .filter(kode => kode !== null && kode !== undefined && kode !== '')
      )
      if (!allowed.size) return
      this.selectedProducts = this.selectedProducts.filter(product => {
        const kode = product?.KODE
        if (kode === null || kode === undefined || kode === '') return false
        return allowed.has(kode)
      })
    },

    createPCC() {
      if (!this.form.banner_image_home) {
        this.$notif('Error', 'Banner Home is required.', 'error')
        return
      }

      this.isLoading = true
      this.$http
        .post('/pcc/product', {
          ...this.form,
          speakers: this.speakers.map(speaker => speaker.speaker),
          speaker_positions: this.speakers.map(speaker => speaker.position),
          categories_id: this.selectedCategories.map(cat => cat.id),
          products_kode: this.selectedProducts.map(product => product.KODE),
          attachments: this.attachments.map(item => item.path),
        })
        .then(() => {
          this.$notif('Success', 'PCC has been successfully added.', 'success')
          this.$router.push({ name: 'admin-pcc-index' })
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data.message}`, 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    addSpeaker() {
      this.speakers.push({
        key: Math.random(),
        speaker: '',
        position: '',
      })
    },

    removeSpeaker(key) {
      this.speakers = this.speakers.filter(speaker => speaker.key !== key)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
